import { S3ConnectRequestSchema } from '@vy/api-definition';
import type { oz } from '@vy/utils';

export const S3RegisterFormSchema = S3ConnectRequestSchema;

export type S3RegisterFormValues = oz.infer<typeof S3RegisterFormSchema>;
